import { useState } from "react";
import { Check, Download, LoaderCircle, Puzzle, RefreshCw, ShieldCheck, X } from "lucide-react";
import { downloadEmailScannerExtension } from "../extensionInstaller";
import { EMAIL_SCANNER_EXTENSION } from "../projectSettings";

export default function ExtensionSetupDialog({ scannerStatus, onClose }) {
  const [downloadStatus, setDownloadStatus] = useState("idle");
  const [error, setError] = useState("");

  async function downloadExtension() {
    setDownloadStatus("loading");
    setError("");
    try {
      await downloadEmailScannerExtension();
      setDownloadStatus("done");
    } catch (downloadError) {
      setDownloadStatus("error");
      setError(downloadError.message || "Die Erweiterung konnte nicht heruntergeladen werden.");
    }
  }

  return <div className="confirm-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className="extension-dialog" role="dialog" aria-modal="true" aria-labelledby="extension-setup-title">
      <header><div className="extension-dialog-icon"><Puzzle /></div><div><p className="eyebrow">Chrome-Erweiterung</p><h2 id="extension-setup-title">E-Mail-Scanner einrichten</h2></div><button type="button" className="icon-button soft" onClick={onClose} aria-label="Schließen"><X /></button></header>
      <div className="extension-version-row">
        <span><strong>Benötigt</strong> Version {EMAIL_SCANNER_EXTENSION.currentVersion}</span>
        <span className={scannerStatus.isCurrent ? "version-current" : "version-missing"}>{scannerStatus.isCurrent ? <Check /> : <RefreshCw />}{scannerStatus.isInstalled ? `Installiert: ${scannerStatus.installedVersion}` : "Nicht installiert"}</span>
      </div>
      <div className="storage-note"><ShieldCheck /><span>Das ZIP liegt geschützt im Firebase Storage und kann nur von angemeldeten MarkenGroup-/MarkenBreit-Admins geladen werden.</span></div>
      <ol className="extension-steps">
        <li><strong>ZIP herunterladen</strong> und im Finder vollständig entpacken.</li>
        <li>In Chrome <code>chrome://extensions</code> öffnen.</li>
        <li>Oben rechts den <strong>Entwicklermodus</strong> aktivieren.</li>
        {scannerStatus.isInstalled && <li>Die bisherige <strong>MarkenGroup LeadMagnet E-Mail Scanner</strong>-Erweiterung entfernen, damit nicht zwei Versionen parallel laufen.</li>}
        <li><strong>Entpackte Erweiterung laden</strong> und den entpackten Ordner auswählen.</li>
        <li>Diese Admin-Seite anschließend neu laden.</li>
      </ol>
      {error && <div className="error-box" role="alert">{error}</div>}
      {downloadStatus === "done" && <div className="notice"><Check /> Download gestartet. ZIP jetzt entpacken und in Chrome laden.</div>}
      <footer><button type="button" className="button ghost" onClick={onClose}>Schließen</button><button type="button" className="button primary" onClick={downloadExtension} disabled={downloadStatus === "loading"}>{downloadStatus === "loading" ? <LoaderCircle className="spin" /> : <Download />} {scannerStatus.isInstalled ? "Aktuelle Version herunterladen" : "Extension als ZIP herunterladen"}</button></footer>
    </section>
  </div>;
}
